<template>
	<h4>HI</h4>
</template>
<script>
export default{

	methods:{

	}
}
</script>